export function scheduleDeferredTask(task: () => void): () => void {
  const timer = setTimeout(task, 0);
  return () => clearTimeout(timer);
}
